import { sendStats } from "./stats";

export const wideo = () => {
  document.querySelectorAll(".player").forEach((playerEl, i) => {
    playerEl.id = "player_" + i;
    const url = playerEl.dataset.url;

    WP.push(() => {
      let playerInitialized = false;
      let statsQuadrantsPos = {};
      let clipName, clipMid;

      const player = new WP.player({
        url,
        target: "player_" + i,
        adv: false,
        hiderelated: true,
        extendedrelated: false,
        floatingplayer: false,
        autoplay: false,
        forceliteembed: false,
      });

      player.on("INIT", () => {
        if (!playerInitialized) playerInitialized = true;
      });

      player.on("START_MOVIE", () => {
        const data = player.getClipData();
        clipName = data.title;
        clipMid = data.mid;
        document.querySelectorAll(".section--head--button").forEach(el => el.style.display = "none");
        sendStats("video", "view", clipName);
      });

      player.on("END_MOVIE", () => {
        document.querySelectorAll(".section--head--button").forEach(el => el.style.display = "block");
        sendStats("video", "end", clipName);
      });

      player.on("UPDATE_POSITION", () => {
        const position = player.getPosition();
        statsQuadrants(position);
      });

      const statsQuadrants = (p) => {
        p = Math.round(p * 100);
        statsQuadrantsPos[clipMid] ||= {};

        if (p >= 25 && p < 50 && !statsQuadrantsPos[clipMid][25]) {
          statsQuadrantsPos[clipMid][25] = 1;
          sendStats("video", "quarter=25", clipName);
        }
        if (p >= 50 && p < 75 && !statsQuadrantsPos[clipMid][50]) {
          statsQuadrantsPos[clipMid][50] = 1;
          sendStats("video", "quarter=50", clipName);
        }
        if (p >= 75 && p < 100 && !statsQuadrantsPos[clipMid][75]) {
          statsQuadrantsPos[clipMid][75] = 1;
          sendStats("video", "quarter=75", clipName);
        }
      };

      // -------------------------
      // TEASERS + CHANGE VIDEO
      // -------------------------
      const section = playerEl.closest(".section_wideo, .section-wideo");
      if (!section) return;

      const teasers = section.querySelectorAll(".wideo-teaser");
      const descBox = section.querySelector(".player__desc");

      // Load thumbnails
      teasers.forEach(teaser => {
        const mid = teaser.dataset.mid;
        if (!mid) return;

        fetch(`https://wideo.wp.pl/player/embed.json?mid=${mid}/secured`)
          .then(res => res.json())
          .then(data => {
            teaser.querySelector("img").src = data.clip.screenshot;
          });
      });

      // On click → change video
      teasers.forEach(teaser => {
        teaser.addEventListener("click", () => {
          const newUrl = teaser.dataset.url;

          // update desc
          if (descBox) {
            descBox.innerHTML = teaser.querySelector(".wideo-teaser__desc").innerHTML;
          }

          // update player
          player.setUrl(newUrl);
          setTimeout(() => {
            if (!player.isPlaying()) player.setUrl(newUrl);
          }, 250);

          // update attributes
          playerEl.dataset.url = newUrl;
          playerEl.dataset.mid = teaser.dataset.mid;

          // scroll do playera
          playerEl.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        });
      });
    });
  });
};
